import './Acl.css'
import { useState, useEffect } from 'react'
import { Col, Dropdown, Modal, ModalBody, ModalFooter, ModalHeader, Row } from 'react-bootstrap'
import Chart from '../Chart'
import doRequest from '../../../requests/requests'
import Button from 'react-bootstrap/Button'
import { DraggableModalDialog } from '../DraggableModalDialog'
import { Resizable } from "re-resizable"
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';

function Acl({ acl, unsetAcl, children, images }) {
    const originalLink = acl?.links?.find((link) => link?.rel.includes('original'))?.href

    const [selectedIndex, setSelectedIndex] = useState(0);
    const [selectedIndex2, setSelectedIndex2] = useState(1);
    var range = commonRange(acl.properties.pAcl.acl.acel[selectedIndex], acl.properties.pAcl.acl.acel[selectedIndex2]);
    var tickv = tickValues(range[0], range[1]);

    const [displayGraph, setDisplayGraph] = useState({
        type: 'line',
        name: "acelerogram",
        x: acl.properties.pAcl.acl.time,
        y: acl.properties.pAcl.acl.acel[selectedIndex],
    })

    const [layout, setLayout] = useState({
        title: `Acelerogram - ${acl.properties.pAcl.names[selectedIndex]}`,
        autosize: true,
        margin: { t: 60, b: 60, l: 30, r: 30 },
        xaxis: { title: 'Time' },
        yaxis: {
            title: 'Displacement',
            range: range,
            ticks: tickv
        },
        
    })

    const [displayGraph2, setDisplayGraph2] = useState({
        type: 'line',
        name: "acelerogram",
        x: acl.properties.pAcl.acl.time,
        y: acl.properties.pAcl.acl.acel[selectedIndex2],
    })

    const [layout2, setLayout2] = useState({
        title: `Acelerogram - ${acl.properties.pAcl.names[selectedIndex2]}`,
        autosize: true,
        margin: { t: 60, b: 60, l: 30, r: 30 },
        xaxis: { title: 'Time' },
        yaxis: {
            title: 'Displacement',
            range: range,
            ticks: tickv
        },
        
    })


    const download = () => {
        doRequest({ onProgress: 'undefined', uri: originalLink, method: 'GET' }).then(
            async (res) => {
                if (res.status === 200) {
                    const file = URL.createObjectURL(await res.blob())
                    let a = document.createElement('a')
                    a.download = acl.properties.name
                    a.href = file
                    a.click()
                }
            }
        )
    }

    const [graphMode, setgraphMode] = useState('accel')

    useEffect(() => {
        if (graphMode === 'accel') {
            var range = commonRange(acl.properties.pAcl.acl.acel[selectedIndex], acl.properties.pAcl.acl.acel[selectedIndex2]);
            var tickv = tickValues(range[0], range[1]);

            //Update first graph
            setDisplayGraph({
                type: 'line',
                name: 'acelerogram',
                x: acl.properties.pAcl.acl.time,
                y: acl.properties.pAcl.acl.acel[selectedIndex],
            });

            setLayout({
                title: `Acelerogram - ${acl.properties.pAcl.names[selectedIndex]}`,
                
                margin: { t: 60, b: 60, l: 30, r: 30 },
                xaxis: { title: 'Time' },
                yaxis: {
                    title: 'Displacement',
                    range: range,
                    tickvals: tickv
                },
                
            });

            //Second graph
            setDisplayGraph2({
                type: 'line',
                name: 'acelerogram',
                x: acl.properties.pAcl.acl.time,
                y: acl.properties.pAcl.acl.acel[selectedIndex2],
            });

            setLayout2({
                title: `Acelerogram - ${acl.properties.pAcl.names[selectedIndex2]}`,

                margin: { t: 60, b: 60, l: 30, r: 30 },
                xaxis: { title: 'Time' },
                yaxis: {
                    title: 'Displacement',
                    range: range,
                    tickvals: tickv
                },
                
            });
        } else {
            var range = commonRange(acl.properties.pAcl.fft.magnitudes[selectedIndex], acl.properties.pAcl.fft.magnitudes[selectedIndex2]);
            var rangefft = [0, range[1]];
            var tickv = tickValues(range[0], range[1]);
            var tickvfft = [tickv[2], tickv[3], tickv[4]];

            //First graph
            setDisplayGraph({
                type: 'line',
                name: 'acelerogram',
                x: acl.properties.pAcl.fft.frequencies[selectedIndex],
                y: acl.properties.pAcl.fft.magnitudes[selectedIndex],
            });

            setLayout({
                title: `Acelerogram FFT - ${acl.properties.pAcl.names[selectedIndex]}`,
                autosize: true,
                xaxis: { title: 'Frequency' },
                yaxis: {
                    title: 'Magnitude',
                    range: rangefft,
                    tickvals: tickvfft
                },
                
            });

            //Second graph
            setDisplayGraph2({
                type: 'line',
                name: 'acelerogram',
                x: acl.properties.pAcl.fft.frequencies[selectedIndex2],
                y: acl.properties.pAcl.fft.magnitudes[selectedIndex2],
            });

            setLayout2({
                title: `Acelerogram FFT - ${acl.properties.pAcl.names[selectedIndex2]}`,
                autosize: true,
                xaxis: { title: 'Frequency' },
                yaxis: {
                    title: 'Magnitude',
                    range: rangefft,
                    tickvals: tickvfft
                },
                
            });
        }
    }, [selectedIndex, selectedIndex2, graphMode, acl]);


    // Changing between fft and acel
    const handleRadioChange = (event) => {
        setgraphMode(event.target.value);
    };
    const sensores = images.find(
        (link) => link?.title.includes('_sensores'))

        
    /*  used to remove dragability for small resolutions */
    const modalDialog = window.innerWidth > 768 ? DraggableModalDialog : undefined;

    return (
        <Modal show={acl !== undefined} onHide={() => unsetAcl()} dialogAs={modalDialog} backdrop='static'>
            <div className="modal-resizable"
                defaultSize={{
                    width: "auto",
                    height: "auto"
                }} lockAspectRatio={'true'}> {/*minHeight={'750px'} minWidth={'830px'}  */}
                <ModalHeader closeButton className="modal-header">
                    <Modal.Title>{acl.properties.name}</Modal.Title>
                </ModalHeader>


                <ModalBody className='acl-modal-body'>

                    <Col md='5' className='side-col'>
                        <Row className='img-row'>
                            {sensores && (
                                <img src={sensores.href} className='sensores-img' alt='' />
                            )}

                        </Row>
                        <div class="info-row">
                            {acl.properties.pAcl.header[0]?.map((item, index) => {
                                return (
                                    <div className='header-item'>
                                        {item} &nbsp;{acl.properties.pAcl.header[1][index]}
                                    </div>
                                )
                            })}
                        </div>
                        <Row className='graph-type-row'>
                            <FormControl variant="standard">
                                <FormLabel id="displacement-radios">Graph Type</FormLabel>
                                <RadioGroup
                                    className='graph-radio-group'
                                    aria-labelledby="displacement-radios"
                                    defaultValue="accel"
                                    value={graphMode}
                                    onChange={handleRadioChange}
                                >
                                    <FormControlLabel value="accel" control={<Radio />} label="Accelerogram" />
                                    <FormControlLabel value="fft" control={<Radio />} label="FFT" />
                                </RadioGroup>
                            </FormControl>
                        </Row>


                    </Col>
                    <Col className='acl-main-col'>
                        <p className='acl-title'>Measured Accelerogram/Spectrogram</p>
                        <Row className='graph-btn-row'>
                            <Dropdown className='dropdown'>
                                <Dropdown.Toggle variant="outline-primary" id="acl-dropdown-basic" >
                                    Graph 1
                                </Dropdown.Toggle>
                                <Dropdown.Menu className='dropdown-menu'>
                                    {acl.properties.pAcl.names?.map((entry, index) => (
                                        <Dropdown.Item
                                            key={index}
                                            active={acl.properties.pAcl.names[selectedIndex] === entry}
                                            onClick={() => {
                                                setSelectedIndex(index)
                                            }}
                                        >
                                            {entry}
                                        </Dropdown.Item>
                                    ))}
                                </Dropdown.Menu>
                            </Dropdown>
                        </Row>
                        <Row className='chart-container'>
                            <Chart className='chart' data={[displayGraph]} layout={layout} />
                        </Row>

                        <Row className='graph-btn-row'>
                            <Dropdown className='dropdown'>
                                <Dropdown.Toggle variant="outline-primary" id="acl-dropdown-basic">
                                    Graph 2
                                </Dropdown.Toggle>
                                <Dropdown.Menu className='dropdown-menu'>
                                    {acl.properties.pAcl.names?.map((entry, index) => (
                                        <Dropdown.Item
                                            key={index}
                                            active={acl.properties.pAcl.names[selectedIndex2] === entry}
                                            onClick={() => {
                                                setSelectedIndex2(index)
                                            }}
                                        >
                                            {entry}
                                        </Dropdown.Item>
                                    ))}
                                </Dropdown.Menu>
                            </Dropdown>
                        </Row>
                        <Row className='chart-container'>
                            <Chart className='chart' data={[displayGraph2]} layout={layout2} />
                        </Row>
                    </Col>

                </ModalBody>


                <ModalFooter>
                    {originalLink && <Button onClick={() => download()}>Download</Button>}
                    {children}
                </ModalFooter>
            </div>
        </Modal>
    )
}

function commonRange(arr1, arr2) {
    // Determine the common range for 1 axis between 2 arrays
    const min = Math.min(Math.min(...arr1), Math.min(...arr2));
    const max = Math.max(Math.max(...arr1), Math.max(...arr2));

    const maxAbs = Math.max(Math.abs(min), Math.abs(max));
    const roundedUpAbs = Math.ceil(maxAbs * Math.pow(10, 1)) / Math.pow(10, 1);

    return [-roundedUpAbs, roundedUpAbs]
}

function tickValues(min, max) {
    const absMax = Math.max(Math.abs(min), Math.abs(max));
    const roundedUp = Math.ceil(absMax * Math.pow(10, 1)) / Math.pow(10, 1);
    const interval = roundedUp / 2;
    return Array.from({ length: 5 }, (_, index) => (-roundedUp + index * interval));
}


export default Acl
